// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d739a654","83":"447d4bbc","287":"6473ea84","324":"2cb27c0d","425":"9cea25ec","618":"e83cc1d4"}[chunkId] + ".chunk.js";
};